import useSWR from 'swr';
import { monday } from '../services/monday';

export type MondayContext = {
  boardId: number;
  user: {
    id: string;
  };
};

// shared by the widget list and the editor - SWR dedupes on the key, so the context is fetched once
export function useMondayContext() {
  return useSWR(
    `/monday-context`,
    async () => {
      const mContext = ((await monday.get('context')) as any).data as MondayContext;

      if (!mContext) {
        throw new Error('This app can only be used inside of monday.com');
      }

      return mContext;
    },
    {
      revalidateIfStale: false,
      revalidateOnFocus: false,
    },
  );
}
